import { HttpInterceptorFn } from '@angular/common/http';
import { injectApiUrl, injectCdnUrl } from '@seatix/shared-config';

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
  const cdnUrl = injectCdnUrl();
  const apiUrl = injectApiUrl();

  const publicApiUrl = `${apiUrl}/api/public`;

  const isApiRequest = req.url.startsWith(apiUrl);
  // `req.url` never carries the query string (`urlWithParams` does), so the
  // catalog root `GET /api/public?…` matches the exact form; `/api/publicX` matches neither.
  const isPublicApiRequest =
    req.url === publicApiUrl || req.url.startsWith(`${publicApiUrl}/`);
  // Sin CDN configurado (control-hub provee '' y, en CI, fan-portal no define
  // STX_CDN_URL) nada es una petición al CDN; `includes('')` lo sería todo.
  const isCdnRequest = !!cdnUrl && req.url.startsWith(cdnUrl);

  // Public API endpoints and CDN objects are anonymous and edge-cached. Credentials
  // would force the origin to reflect the Origin and break `Access-Control-Allow-Origin: *`,
  // and any non-safelisted header (`Content-Type: application/json`, `Cache-Control`,
  // `Pragma`) would trigger a CORS preflight on every request — both defeat edge
  // caching, and the CDN objects declare their own `max-age`. Keep these GETs simple.
  if (isCdnRequest) {
    return next(req.clone({ withCredentials: false }));
  }

  const shouldAddContentType =
    !isPublicApiRequest &&
    !req.headers.has('Content-Type') &&
    req.responseType !== 'blob' &&
    !(req.body instanceof FormData);

  const headers: { [key: string]: string } = {};

  if (shouldAddContentType) {
    headers['Content-Type'] = 'application/json';
  }

  return next(
    req.clone({
      setHeaders: headers,
      withCredentials: isApiRequest && !isPublicApiRequest,
    }),
  );
};
